import {
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useEffect, useState } from "react";
import useToast from "../../../../hooks/useToast";
import useConfirm from "../../../../hooks/useConfirm";
import { TYPE_NOTIFICATION } from "../../shares/NotificationBull";
import AppButton from "../../shares/AppButton";
import StandardSkeletoon from "../../shares/loader/StandardSkeletoon";
import { AdministrateurService } from "../../../../service/admin_service/AdministrateurService";
import useCrudApi from "../../../../hooks/useCrudApi";
import AppCardHeader from "../../shares/reusable/AppCardHeader";
import { PgiUserService } from "../../../../service/admin_service/PgiUserService";

const INIT_ADMIN_INFO = {
  role: "7",
  id_ext_user: "0",
  nom: "",
  prenoms: "",
  email: "",
  is_association: "3",
  password: "12345678",
};

const INIT_FORM_ERROR = {
  role_error: null,
  id_ext_user_error: null,
  nom_error: null,
  prenom_error: null,
  email_error: null,
};

const AdministrateursDialogForm = ({
  open,
  onFormClose,
  onFormOpen,
  idUserAdmin,
  admin_info,
}) => {
  const [adminInfo, setAdminInfo] = useState(INIT_ADMIN_INFO);
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const [submited, setSubmited] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const { Toast, showToast } = useToast();
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const adminApi = useCrudApi(AdministrateurService);
  const pgiUserApi = useCrudApi(PgiUserService);

  const handleFormClose = () => {
    onFormClose();
    setAdminInfo(INIT_ADMIN_INFO);
  };

  const handleChangeAMIInfo = (e) => {
    const { name, value } = e.target;
    setAdminInfo({ ...adminInfo, [name]: value });
  };

  const handleFetchAdminInfo = () => {
    setFormLoading(true);
    AdministrateurService.find_one({ id_ext_user: idUserAdmin })
      .then((res) => {
        if (res && res.data) {
          setAdminInfo(res.data);
        }
      })
      .finally(() => {
        setFormLoading(false);
      });
  };

  const handleCheckDataValidation = () => {
    setFormErrors({
      role_error: adminInfo.role ? null : "Le rôle est obligatoire",
      /* nom_error: adminInfo.nom ? null : "Le nom est obligatoire",
      prenom_error: adminInfo.prenom ? null : "Le prenom est obligatoire",
      email_error: adminInfo.email ? null : "L'email est obligatoire", */
      nom_error: null,
      prenom_error: null,
      email_error: null,
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  const handleSave = () => {
    if (idUserAdmin) {
      handleUpdate();
    } else {
      handleInsert();
    }
  };
  const handleInsert = () => {
    setSubmited(true);
    setLoading(true);
    const new_admin = {
      role: adminInfo.role,
      nom: admin_info?.last_name,
      prenoms: admin_info?.first_name,
      email: admin_info?.email,
      adresse: admin_info?.address || "",
      telephone: admin_info?.emergency_phone || "0320000000",
      annee_naissance: admin_info?.birth_year || "2000",
      is_association: "3",
      password: "12345678",
    };
    AdministrateurService.insert_admin(new_admin)
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmited(false);
        setLoading(false);
      });
  };

  const handleUpdate = () => {
    setSubmited(true);
    setLoading(true);
    AdministrateurService.update_admin(adminInfo)
      .then((res) => {
        if (res && res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setSubmited(false);
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    setSubmited(true);
    if (handleCheckDataValidation()) {
      handleSave();
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
    }
  };

  useEffect(() => {
    if (adminInfo) {
      handleCheckDataValidation();
    }
  }, [adminInfo]);

  useEffect(() => {
    /*   if (idUserAdmin && open) {
      handleFetchAdminInfo();
    } */
    if (!idUserAdmin && open) {
      pgiUserApi.findOne({ id_ext_user: idUserAdmin });
    } else {
      adminApi.run("find_one", { id_ext_user: idUserAdmin });
    }
  }, [idUserAdmin, open]);

  useEffect(() => {
    if (adminApi.data.findOneById) {
      const adm_info = adminApi.data.findOneById?.data;
      setAdminInfo({
        ...adminInfo,
        nom: adm_info?.nom + " " + adm_info?.prenoms,
      });
    } else if (pgiUserApi.data.findOne) {
      const adm_info = pgiUserApi.data.findOne?.data;
      setAdminInfo({
        ...adminInfo,
        nom: adm_info?.last_name + " " + adm_info?.first_name,
      });
    }
  }, [adminApi.data.findOneById, pgiUserApi.data.findOne]);

  useEffect(() => {
    console.log("admin info: ", adminApi?.data.find_one?.data);
  }, [adminInfo]);

  return (
    <>
      <DialogComponent />
      <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="sm">
        <Toast />
        <Grid>
          <StandardSkeletoon escalier={true} m={4} row={4} show={formLoading} />
        </Grid>
        <Paper
          sx={{ m: 3, display: formLoading ? "none" : "block" }}
          elevation={0}
        >
          <Grid>
            <CardHeader
              title={idUserAdmin ? "Modifier Admin" : "Ajouter Admin"}
            />
            <CardContent>
              <Grid container>
                <AppCardHeader
                  loading={
                    adminApi.loading.findOneById || pgiUserApi.loading.findOne
                  }
                  title={adminInfo.nom + " " + adminInfo.prenoms}
                  subheader={adminInfo.email}
                />
                {/* <p>{adminInfo.nom || "dfsf"}</p> */}
                <FormControl
                  fullWidth
                  error={formErrors.role_error && submited}
                >
                  <label>Privilege</label>
                  <RadioGroup
                    row
                    onChange={(e) => handleChangeAMIInfo(e)}
                    value={adminInfo.role || "4"}
                    name="role"
                  >
                    <FormControlLabel
                      value="4"
                      control={<Radio />}
                      label="Moderateur"
                      disabled
                    />
                    <FormControlLabel
                      value="7"
                      control={<Radio />}
                      label="Administrateur"
                    />
                  </RadioGroup>
                  {formErrors.role_error && submited && (
                    <FormHelperText>{formErrors.role_error}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <AppButton
                loading={loading}
                text={"Enregistrer"}
                variant={"contained"}
                size={"medium"}
                onClick={(e) => handleSubmit()}
              />
              <AppButton
                text={"Fermer"}
                size={"medium"}
                variant={"outlined"}
                onClick={(e) => handleFormClose()}
              />
            </CardActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default AdministrateursDialogForm;
